import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { ACTIVE_CALLER_SESSION, ACTIVE_CALLER_SESSION_SUCCESS, ACTIVE_CALLER_SESSION_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getActiveCallerSession({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/customer-sessions`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: ACTIVE_CALLER_SESSION_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: ACTIVE_CALLER_SESSION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: ACTIVE_CALLER_SESSION_ERROR, payload: error });
  }
}

export function* watchActiveCallerSession() {
  yield takeEvery(ACTIVE_CALLER_SESSION, getActiveCallerSession);
}

function* watchActiveCallerSessionSaga() {
  yield all([fork(watchActiveCallerSession)]);
}

export default watchActiveCallerSessionSaga;
